import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Lazy load components for better performance
const RotaExecutivaLanding = lazy(() => import("./components/RotaExecutivaLanding"));
const AdminPanel = lazy(() => import("./components/AdminPanel"));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Carregando...</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<RotaExecutivaLanding />} />
            <Route path="/painel" element={<AdminPanel />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;